export function setLocalStorage<T>(name: string, data: T) {
  return localStorage.setItem(name, JSON.stringify(data));
}

export function getLocalStorage<T>(name: string): T | null {
  try {
    const data = localStorage.getItem(name);

    if (!data) {
      return null;
    }

    return JSON.parse(data) as T;
  } catch (error) {
    return null;
  }
}

export function removeLocalStorage(name: string) {
  return localStorage.removeItem(name);
}
